import { useLang } from "@/i18n/LanguageContext";

/**
 * Original DataLeo editorial illustration: a connected operational decision
 * system. No external photographs, fake UI screenshots or client data.
 */
const labels = {
  en: {
    top: "DECISION SYSTEM / 01",
    demand: "DEMAND", supply: "SUPPLY", inventory: "INVENTORY",
    decision: "DECISION", output: "ACTION", model: "SCENARIO / TRADE-OFF",
    bottom: "Signals → decisions → execution",
  },
  fr: {
    top: "SYSTÈME DE DÉCISION / 01",
    demand: "DEMANDE", supply: "APPRO.", inventory: "STOCK",
    decision: "DÉCISION", output: "ACTION", model: "SCÉNARIO / ARBITRAGE",
    bottom: "Signaux → décisions → exécution",
  },
};

const Node = ({ x, y, title, featured = false }) => (
  <g transform={`translate(${x} ${y})`}>
    <rect x="-71" y="-25" width="142" height="50" rx="8"
      fill={featured ? "#00A878" : "#18342B"}
      stroke={featured ? "#73F3C7" : "#386052"} strokeWidth="1.5" />
    <circle cx="-51" cy="0" r="3.5" fill={featured ? "#09251C" : "#00D7A1"}/>
    <text x="8" y="4" textAnchor="middle" fill={featured ? "#09251C" : "#E9FBF2"}
      fontFamily="ui-monospace, monospace" fontSize="11" fontWeight="700" letterSpacing="1">{title}</text>
  </g>
);

export default function DecisionNetworkGraphic() {
  const { lang } = useLang();
  const t = labels[lang] || labels.en;
  return (
    <div className="relative w-full rounded-[24px] overflow-hidden bg-[#0A1F18] border border-[#2E4B40] shadow-[0_25px_70px_rgba(10,31,24,0.18)]" role="img"
      aria-label={lang === "fr" ? "Schéma conceptuel DataLeo reliant la demande, le stock et l'approvisionnement à une décision puis une action." : "DataLeo conceptual diagram connecting demand, inventory and supply into a decision and an action."}>
      <svg viewBox="0 0 520 500" className="w-full h-auto" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="network-grid" width="26" height="26" patternUnits="userSpaceOnUse">
            <path d="M 26 0 L 0 0 0 26" stroke="#315445" strokeOpacity="0.22" fill="none" strokeWidth="0.7"/>
          </pattern>
          <linearGradient id="network-stroke" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%" stopColor="#00A878" stopOpacity="0.4"/>
            <stop offset="100%" stopColor="#8FFFD6"/>
          </linearGradient>
        </defs>
        <rect width="520" height="500" fill="#0A1F18"/>
        <rect width="520" height="500" fill="url(#network-grid)"/>
        <text x="36" y="49" fill="#A5D0BF" fontFamily="ui-monospace, monospace" letterSpacing="2" fontSize="10">{t.top}</text>
        <path d="M 36 65 H 484" stroke="#315445" strokeWidth="1"/>
        <g stroke="url(#network-stroke)" strokeWidth="1.7" fill="none">
          <path d="M 173 150 C 220 150, 215 245, 265 245" />
          <path d="M 173 250 H 265" />
          <path d="M 173 350 C 220 350, 215 245, 265 245" />
          <path d="M 330 245 H 425" />
        </g>
        <g fill="#86FDD0">
          <circle cx="211" cy="173" r="3"/><circle cx="222" cy="250" r="3"/>
          <circle cx="223" cy="315" r="3"/><circle cx="379" cy="245" r="3"/>
        </g>
        <Node x={105} y={150} title={t.demand}/>
        <Node x={105} y={250} title={t.inventory}/>
        <Node x={105} y={350} title={t.supply}/>
        <g transform="translate(288 245)">
          <circle r="64" fill="#0B3E2D" stroke="#00A878" strokeWidth="2"/>
          <circle r="49" fill="none" stroke="#00A878" strokeWidth="1" strokeDasharray="2 6" opacity="0.7"/>
          <text y="-2" textAnchor="middle" fill="#E8FFF4" fontFamily="ui-monospace, monospace" fontWeight="700" fontSize="12">{t.decision}</text>
          <text y="17" textAnchor="middle" fill="#8BEBC3" fontFamily="ui-monospace, monospace" fontSize="8">{t.model}</text>
        </g>
        <g transform="translate(442 245)">
          <rect x="-49" y="-29" width="85" height="58" rx="8" fill="#00A878" />
          <text x="-6" y="5" textAnchor="middle" fill="#09251C" fontFamily="ui-monospace, monospace" fontSize="10" fontWeight="700">{t.output}</text>
        </g>
        <path d="M 36 422 H 484" stroke="#315445" strokeWidth="1"/>
        <text x="36" y="449" fill="#D5F6E6" fontFamily="ui-monospace, monospace" fontSize="12">{t.bottom}</text>
        <text x="36" y="472" fill="#669D87" fontFamily="ui-monospace, monospace" fontSize="9" letterSpacing="1.4">DATALEO / SUPPLY CHAIN DECISION SYSTEMS</text>
      </svg>
    </div>
  );
}
